export const sortBy = <I, K extends keyof I>(array: I[], key: K): I[] => {
  return array.sort((a, b) => {
    if (a[key] > b[key]) {
      return 1
    }

    if (a[key] < b[key]) {
      return -1
    }

    return 0
  })
}

export const keyByToMap = <I, K extends keyof I>(array: I[], key: K) => {
  type R = I[K]
  return array.reduce((acc, item) => {
    acc.set(item[key], item)
    return acc
  }, new Map<R, I>())
}
